import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/bookingsSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

export const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarEndDate },
    minDate,
    maxDate
  } = useSelector((state) => {
    let { selectedRequestDates, currentUser, minDate, maxDate } = state.bookings;
    return { selectedRequestDates, currentUser, minDate, maxDate };
  }, shallowEqual);

  return (
    <>
      <ReactDatePicker
        displayFormat={dateFormat}
        isRangePicker
        startDate={startDate}
        endDate={endDate}
        minDate={minDate}
        maxDate={maxDate}
        calendarEndDate={maxDate ? maxDate : calendarEndDate}
        updateDates={(startDate, endDate) =>
          dispatch(actionCreators.updateDates({ startDate, endDate }))
        }
      />
    </>
  );
};
